import { combineReducers } from "redux";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgotPasswordReducer from "./auth/forgetpwd/reducer";
import AccountReducer from "./auth/register/reducer";
import UserReducer from "./current user/reducer";
import bookingReducer from "./booking/bookingSlice";
import cartReducer from "./booking/cartSlice";

const rootReducer = combineReducers({
    Login: LoginReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgotPasswordReducer,
    Account: AccountReducer,
    user: UserReducer,
    booking: bookingReducer, 
    cart: cartReducer
});

export default rootReducer;